// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"271":"7cb18b5e","327":"641227a2","431":"3ab5d366","434":"d36a8825","594":"13e6c872","638":"0f8a7ce5","659":"897996a8","715":"23de34b8","719":"bbb77608","884":"340adfc7","887":"6ed311ef","987":"42159e59"}[chunkId] + ".js";
};